import videojs from "@/vendor/videojs/video.es.js";
import VirtualDirector from "@/vendor/vd.js";

const Plugin = videojs.getPlugin("plugin");

class HiZoom extends Plugin {
  constructor(player, options) {
    super(player, options);

    this.player = player;
    this.on(player, "zoom", this.zoom);
    this.on(player, "disableZoom", this.disable);
    this.on(player, "enableZoom", this.enable);

    this.player.currentX = 50;
    this.player.currentY = 50;
    this.player.x = 0;
    this.player.y = 0;
    this.player.currentZoom = 150;

    this.mouseDown = false;
    this.onMouseMoveWithThis = this.onMouseMove.bind(this);
    this.onMouseDownWithThis = this.onMouseDown.bind(this);
    this.onMouseUpWithThis = this.onMouseUp.bind(this);

    //remove default click behavior
    player.handleTechClick_ = function() {};

  }
  dispose() {
    super.dispose();
  }
  enable() {
    let that = this;

    this.player.hiliteSports.videoElWrapper.classList.add("zoomed");

    this.player.hiliteSports.videoElWrapper.addEventListener("mousemove", this.onMouseMoveWithThis);
    this.player.hiliteSports.videoElWrapper.addEventListener("mousedown", this.onMouseDownWithThis);
    this.player.hiliteSports.videoElWrapper.addEventListener("mouseup", this.onMouseUpWithThis);
    this.player.hiliteSports.videoElWrapper.addEventListener("mouseleave", this.onMouseUpWithThis);

    //pause autozoom if it's playing
    this.player.hiliteSports.vd.pause();
    this.player.hiliteSports.vd.mode = "user";
  }
  onMouseMove(e) {
    if (this.mouseDown == false) {
      return false;
    }

    let elWidth = e.target.clientWidth;
    let elHeight = e.target.clientHeight;

    let deltaX = this.dragX - e.offsetX;
    let deltaY = this.dragY - e.offsetY;

    this.dragX = e.offsetX;
    this.dragY = e.offsetY;

    this.player.currentX = Math.min(Math.max(this.player.currentX + deltaX, 0), 100) ;
    this.player.currentY = Math.min(Math.max(this.player.currentY + deltaY, 0), 100) ;

    this.player.x = (this.player.currentX * 2 - 100) / - 100;
    this.player.y = (this.player.currentY * 2 - 100) / - 100;

    this.player.hiliteSports.vd.updatePosition(this.player.x, this.player.y, this.player.currentZoom);
  }
  onMouseDown(e) {
    this.mouseDown = true;
    let elWidth = e.target.clientWidth;
    let elHeight = e.target.clientHeight;

    this.dragX = e.offsetX;
    this.dragY = e.offsetY;
  }
  onMouseUp(e) {
    if (this.mouseDown == true) {
      this.mouseDown = false;
    }
  }
  disable() {
    this.player.hiliteSports.videoElWrapper.classList.remove("zoomed")
    this.player.hiliteSports.videoElWrapper.removeEventListener("mousemove", this.onMouseMoveWithThis);
  }
  zoom(triggerEvent, zoomObj) {
    this.player.currentZoom = zoomObj.value;

    let x = (this.player.currentX * 2 - 100) / - 100;
    let y = (this.player.currentY * 2 - 100) / - 100;

    this.player.hiliteSports.vd.updatePosition(x, y, this.player.currentZoom);
  }
}

videojs.registerPlugin("HiZoom", HiZoom);
